import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {IonicPageModule} from "ionic-angular";
import {MatExpansionModule} from '@angular/material/expansion';
import {AutocompleterComponent} from './autocompleter/autocompleter';


@NgModule({
  declarations: [
    AutocompleterComponent,
  ],
  imports: [
    IonicPageModule,
    CommonModule,
    MatExpansionModule
  ],
  exports: [
    AutocompleterComponent
  ]
})
export class ComponentsModule {
}



// WEBPACK FOOTER //
// ./src/components/components.module.ts